<template>
  <div>
    <a-modal title="选择推送对象" v-model="pushMessageVisible" @ok="handleOk" width="800px">
      <div class="push-main">
        <div class="left">
          <a-tree
            defaultExpandAll
            @select="selectTree"
          >
            <a-tree-node v-for="item in data" :title="item.name" :key="item.id">
              <a-tree-node v-for="items in item.children" :title="items.name" :key="items.id" />
            </a-tree-node>
          </a-tree>
        </div>
        <div class="right">
          <div class="title">
            <span>{{ departmentTitle ? departmentTitle :'佳冠集团' }}</span>
            <a-checkbox @change="pushOnChange" class="check-all">全选</a-checkbox>
          </div>
          <div class="main-tag">
            <span v-for="(value) in departmentaPeopleList" :class="pushPeopleList.indexOf(value.id) !== -1 ? 'active':''" @click="pushSele(value.id,value.name)">{{ value.name }}</span>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getDepartmentalList, getDepartmentaPeople, NoticePush } from '@/api/manage'
export default {
  data () {
    return {
      pushMessageVisible: false,
      data: [],
      departmentaPeopleList: [],
      departmentTitle: '',
      pushPeopleList: [],
      seleID: [], // 选择ID集合
      nameList: [], // 姓名集合
      noticeId: '' // 公告id
    }
  },
  methods: {
    show (record, type) {
      this.pushMessageVisible = true
      this.getDepartmental()
      if (type === 2) {
        this.$nextTick(() => {
          this.noticeId = record.id
        })
        this.pushPeopleList = []
      }
    },
    getDepartmental () {
      return getDepartmentalList({})
        .then(res => {
          // console.log(res)
          this.data = res.result
        })
        .finally(() => {
          this.loading = false
        })
    },
    selectTree (selectedKeys, e) {
      this.departmentTitle = e.node.title
      // 获取组织成员
      return getDepartmentaPeople({ departmentId: selectedKeys[0] })
        .then(res => {
          this.departmentaPeopleList = res.result
        })
        .finally(() => {
          this.loading = false
        })
    },
    pushSele (id, name) {
      for (let i = 0; i < this.pushPeopleList.length; i++) {
        if (this.pushPeopleList[i] == id) {
          this.nameList.splice(i, 1)
          this.pushPeopleList.splice(i, 1)
          return
        }
      }
      this.nameList.push(name)
      this.pushPeopleList.push(id)
      // console.log(this.pushPeopleList)
    },
    handleOk (e) {
      // 推送公告
      if (this.noticeId) {
        this.pushNotice()
      } else {
        // console.log(1)
        this.$emit('ok', JSON.stringify(this.pushPeopleList), JSON.stringify(this.nameList))
      }
      this.pushMessageVisible = false
    },
    pushNotice () {
      if (!this.pushPeopleList) {
        this.$message.error('请选择用户')
      }
      return NoticePush({ noticeId: this.noticeId, user_ids: this.pushPeopleList.join(',') })
        .then(res => {
          // console.log(res.result)
        })
        .catch((err) => this.requestFailed(err))
        .finally(() => {
          this.loading = false
        })
    },
    // 推送全选选择框
    pushOnChange (e) {
      if (e.target.checked) {
        this.departmentaPeopleList.forEach((item) => {
          this.pushPeopleList.push(item.id)
          this.nameList.push(item.name)
        })
      } else {
        this.pushPeopleList = []
        this.nameList = []
      }
    },
    requestFailed (err) {
      // console.log(err)
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    }
  }
}
</script>

<style scoped>
  .push-main {
    min-height: 400px;
  }
  .left {
    display: inline-block;
    vertical-align: top;
    width: 200px;
    min-height: 400px;
    /*border-right: 1px solid #ccc;*/
    border: none;
  }
  .right {
    display: inline-block;
    vertical-align: top;
    padding-left: 20px;
    width: 520px;
    min-height: 400px;
    border-left: 1px solid #ccc;
  }
  .right .title {
    font-size: 14px;
    font-weight: 700;
  }
  .right .check-all {
    float: right;
    margin-right: 36px;
  }
  .main-tag {
    width: 100%;
    height: 100%;
  }
  .main-tag span {
    display: inline-block;
    margin-top: 10px;
    line-height: 20px;
    text-align: center;
    padding:4px  14px;
    margin-right: 10px;
    border: 1px solid #ccc;
    cursor: pointer;
    border-radius: 4px;
  }
  .main-tag span:hover {
    background-color: #f2f2f2;
  }
  .quill-editor {
    width: 92%;
    height: 400px;
    margin: 0 auto;
  }
  .submit-style {
    margin-top: 80px;
  }
  .active {
    background-color: #2eabff;
  }
</style>
